import { InputNumber as AntInputNumber } from 'antd';

import { NumberInputProps } from './types';

export const NumberInput = ({ style, onChange, controls = false, min = 0, ...rest }: NumberInputProps) => {
  return (
    <AntInputNumber
      {...{
        controls,
        min,
        style: { width: '100%', ...style },
        type: 'number',
        onWheel: e => e.currentTarget.blur(),
        onKeyDown: e => {
          if (e.key === 'e') {
            e.preventDefault();
          }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange: value => onChange((Number(value) || value) as any),
        ...rest,
      }}
    />
  );
};
